import { DateTime } from 'luxon';
import { z } from 'zod';

import { FormField, getMaxDate, MIN_DATE } from './constants';
import { FormValues } from './types';

export const formValidationSchema = z.object({
  [FormField.dateRange]: z
    .array(z.string().nullable())
    .length(2)
    .check(ctx => {
      const [startDate, endDate] = ctx.value;
      if (!startDate || !endDate) {
        ctx.issues.push({
          code: 'custom',
          message: 'Both start and end dates are required',
          input: ctx.value,
        });
      }

      if (startDate && DateTime.fromISO(startDate) < MIN_DATE) {
        ctx.issues.push({
          code: 'custom',
          message: 'Start date cannot be before January 1, 2025',
          input: ctx.value,
        });
      }

      if (endDate && DateTime.fromISO(endDate) > getMaxDate()) {
        ctx.issues.push({
          code: 'custom',
          message: 'End date cannot be in the future',
          input: ctx.value,
        });
      }
    }),
}) satisfies z.ZodType<FormValues>;
